module.exports = __webpack_public_path__ + "Public/Home/staticmokao/img/part8-zhong.ae2f38a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/part8-zhong.jpg
// module id = RalT
// module chunks = 1